import {
  getLessonsById,
  getModuleById,
  getModuleProgress,
  getLessonProgress,
  getLessonProgressById,
  postModuleProgress,
  postLessonProgress,
} from "@/api/api";
import store from "@/store";

export async function hydratePortalLessonAndEnter(router, lessonUuid, studentEmail) {
  const { data: lessonResponse } = await getLessonsById(lessonUuid);
  const { data: moduleResponse } = await getModuleById(lessonResponse.module);

  let progressResponse = await getModuleProgress({
    module__uuid: moduleResponse.uuid,
    student__email: studentEmail,
  });
  let moduleProgress = progressResponse.data.results[0];
  if (!moduleProgress) {
    const modRes = await postModuleProgress({
      module__uuid: moduleResponse.uuid,
      student__email: studentEmail,
    });
    moduleProgress = modRes.data;
  }

  let lessonProgressList = await getLessonProgress({
    student__email: studentEmail,
    lesson__uuid: lessonResponse.uuid,
  });
  let firstLp = lessonProgressList.data.results[0];
  if (!firstLp) {
    const postRes = await postLessonProgress({
      lesson: lessonResponse.uuid,
      module_progress: moduleProgress.uuid,
      student: studentEmail,
      completed: false,
    });
    firstLp = { uuid: postRes.data.uuid };
  }
  const { data: lessonProgressByUuid } = await getLessonProgressById(firstLp.uuid);

  store.commit("modules/selectedModule", moduleResponse);
  store.commit("progress/module", moduleProgress);
  store.commit("modules/currentLesson", lessonResponse);
  store.commit("progress/lesson", lessonProgressByUuid);

  await store.dispatch("lesson/teacher_lesson", lessonResponse.teacher_lesson);
  await store.dispatch("lesson/practice", lessonResponse.practice);
  await store.dispatch("lesson/grammar", lessonResponse.grammar);

  await router.push({ name: "lesson-view" });
}
